// removed by extract-text-webpack-plugin
module.exports = {"title-and-counter":"title-and-counter","titleAndCounter":"title-and-counter","item-title":"item-title","itemTitle":"item-title","item-counter":"item-counter","itemCounter":"item-counter"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portal/gridTitleAndCount/style.scss
// module id = 1489
// module chunks = 0